import { getBiddingStrategyPerformanceGoalType } from './helpers'

import {
  PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE,
  PERFORMANCE_GOAL_TYPE_CPA,
  PERFORMANCE_GOAL_TYPE_CPC,
  PERFORMANCE_GOAL_TYPE_CPIAVC,
  PERFORMANCE_GOAL_TYPE_CPM,
  PERFORMANCE_GOAL_TYPE_CPV,
  PERFORMANCE_GOAL_TYPE_CTR
} from './CampaignForms/CampaignDv360Create/CampaignDv360CreateForm/fields'

export function getCampaignBidStrategy(campaignPerformanceGoalType) {
  // If campaign performance goal type is CPA, then we automate bid at campaign/IO level
  // Otherwise, we control bid at line item level
  const isAutomateBidAtCampaignLevel = campaignPerformanceGoalType === PERFORMANCE_GOAL_TYPE_CPA

  const biddingStrategyPerformanceGoalType = getBiddingStrategyPerformanceGoalType(campaignPerformanceGoalType)

  return {
    ...(isAutomateBidAtCampaignLevel
      ? {
          maximize_spend_auto_bid: {
            performance_goal_type: biddingStrategyPerformanceGoalType
          }
        }
      : { fixed_bid: {} })
  }
}

export const getGoalAmountFieldDescription = goalType => {
  switch (goalType) {
    case PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE:
      return 'Percentage of complete audio listens per impression'
    case PERFORMANCE_GOAL_TYPE_CTR:
      return 'Please enter a click through rate goal which will be used to keep track of the success of the campaign'
    case PERFORMANCE_GOAL_TYPE_CPC:
      return 'Please enter a cost per click goal which will be used to keep track of the success of the campaign'
    case PERFORMANCE_GOAL_TYPE_CPM:
      return 'Please enter a CPM goal which will be used to keep track of the success of the campaign'
    case PERFORMANCE_GOAL_TYPE_CPIAVC:
      return 'Please enter a CPIAVC goal which will be used to keep track of the success of the campaign'
    case PERFORMANCE_GOAL_TYPE_CPV:
      return "A view is counted when a viewer watches 30 seconds of your video ad (or the duration if it's shorter than 30 seconds) or interacts with the ad"
    case PERFORMANCE_GOAL_TYPE_CPA:
    default:
      return 'Please enter a CPA goal which will be used to keep track of the success of the campaign'
  }
}
